import dayjs from 'dayjs';
import vueI18n from '../plugins/vue-i18n'

export const dashOverviewFilters = {

    translatePerson(person) {

        if (person === 'Person') return vueI18n.t('person')
        if (person === 'Company') return vueI18n.t('company')

    },

    mountLat(coord) {

        return { lat: (coord[0]).toFixed(), lng: (coord[1]).toFixed() }

    },

    replace(number) {

        return number.replace(',', ' / ')

    },

    dateTransform(date) {

        return dayjs(date).format('DD/MM/YYYY HH:mm:ss')

    },

    dateTransformOnlyDate(date) {

        return dayjs(date).format('DD/MM/YYYY')

    },


}